import React from 'react';

import { ExamplePanel } from './example-panel';

export default function DummyEntryPointComponent(): React.JSX.Element {
	return <ExamplePanel />;
}
